import { render, staticRenderFns } from "./ViewerCharsets.vue?vue&type=template&id=4932f618&scoped=true"
import script from "./ViewerCharsets.vue?vue&type=script&lang=js"
export * from "./ViewerCharsets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932f618",
  null
  
)

export default component.exports